import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";

import { UserNameBox, UserName } from "../styles";
import { setUserById } from "../../../store/slices/users";

export const UserHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <UserNameBox
      onClick={() => {
        navigate(-1);
        dispatch(setUserById(undefined));
      }}
    >
      <ChevronLeft />
      <UserName>Users</UserName>
    </UserNameBox>
  );
};
